import React from "react";
import MaterialTableEmp from "../../../../../components/tables/MaterialTableEmp";

interface IProps {
  rowData?: any;
  invoicePhase?: string;
  isLoading?: boolean;
}

const InvoiceItemizedView: React.FC<IProps> = ({
  rowData,
  invoicePhase,
  isLoading = false,
}) => {
  const extractDates = (input: string): string | null => {
    const datePattern = /\d{4}-\d{2}-\d{2} - \d{4}-\d{2}-\d{2}/;
    if (input == null) return null;
    const match = input?.match(datePattern);
    return match ? match[0] : null;
  };

  const materialColumns = [
    {
      title: "Office Name",
      field: "officeName",
    },
    {
      title: "Branch",
      field: "glBranch",
    },
    {
      title: "Transaction Description",
      field: "transactionDescription",
      render: (rowData) => {
        let extractedDates = extractDates(rowData.transactionDescription);
        return extractedDates != null
          ? extractedDates
          : rowData.transactionDescription;
      },
    },
    {
      title: "Unit Cost",
      field: "unitCost",
      render: (rowData) => {
        return rowData.unitCost ? Number(rowData.unitCost).toFixed(2) : "0.00";
      },
    },
    {
      title: "Ext. Cost",
      field: "extCost",
      render: (rowData) => {
        return rowData.extCost ? Number(rowData.extCost).toFixed(2) : "0.00";
      },
    },
    {
      title: "Amount",
      field: "amount",
      render: (rowData) => {
        return rowData.amount ? Number(rowData.amount).toFixed(2) : "0.00";
      },
    },
    {
      title: "Account",
      field: "expenseAccount",
    },
    {
      title: "Sub Account",
      field: "subAccount",
    },
    { title: "Description", field: "expenseDescription" },
  ];
  return (
    <>
      <div className="bg-white border rounded-md overflow-x-auto">
        <div className="overflow-x-auto grid grid-row">
          <MaterialTableEmp
            columns={materialColumns}
            data={
              rowData
                ? rowData?.map((c) => {
                    const { tableData, ...rows } = c;
                    return rows;
                  })
                : []
            }
            isLoading={isLoading}
            pageSize={3}
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceItemizedView;
